/* istanbul ignore file */
export { default } from './CardHeader';
